<vc-form-newsletter
  *ngIf="(blocToShow | async) == 'newsletter'"
  (onUserValidated)="setUser($event)"
  [popinForced]="popinForced"
></vc-form-newsletter>

<vc-form-register
  *ngIf="(blocToShow | async) == 'register'"
  [credentials]="credentials"
  [popinForced]="popinForced"
></vc-form-register>
